import cx from 'classnames'
import type React from 'react'
import { useEffect, useState } from 'react'

import css from './Switcher.module.scss'

interface Props {
  items: {
    content: React.ReactNode
    checked: boolean
    disabled?: boolean
  }[]
  size?: 'small' | 'medium' | 'large'
  shape?: 'text' | 'icon'
  onClick: (index: number) => void
}

const Switcher: React.FC<Props> = ({
  items,
  size,
  shape = 'text',
  onClick,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0)

  const checkedKey = items.map((item) => item.checked).join()

  // The parent owns the choice: a click it does not accept leaves the
  // indicator where it was.
  useEffect(() => {
    items
      .filter((item) => !item.disabled)
      .forEach((item, index) => {
        if (item.checked) {
          setSelectedIndex(index)
        }
      })
  }, [checkedKey])

  const handleOnClick = (index: number) => {
    setSelectedIndex(index)
    onClick(index)
  }

  const sizeClassName = size || 'medium'
  const shapeClassName = shape || 'text'
  const switcherStyle = {
    transform: `translateX(calc(100% * ${selectedIndex}))`,
    minWidth: `${100 / items.length}%`,
  }

  return (
    <div className={cx(css.container, css[sizeClassName], css[shapeClassName])}>
      {items
        .filter((item) => !item.disabled)
        .map((item, index) => (
          <div
            key={index}
            className={cx(css.item, { [css.noneHover]: item.checked })}
            onClick={() => handleOnClick(index)}
          >
            {item.content}
          </div>
        ))}
      <div className={css.switcher} style={switcherStyle} />
    </div>
  )
}

export default Switcher
